<template>
  <div id="WellbeingCourse">
    <div class="page-header bg-grey py-5">
      <div class="content-container row">
        <div class="page-title col-12 col-md-5">
          <b-button
            class="return p-0 pb-4"
            @click="$router.back()"
            alt="return to all courses"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.13 35.13">
              <defs></defs>
              <title>arrow-left</title>
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <circle class="cls-1" cx="17.56" cy="17.56" r="17.56" />
                  <rect
                    class="cls-2"
                    x="9.82"
                    y="16.6"
                    width="15.95"
                    height="2.13"
                  />
                  <polygon
                    class="cls-2"
                    points="14.22 23.47 8.05 17.5 14.22 11.53 15.7 13.06 11.11 17.5 15.7 21.94 14.22 23.47"
                  />
                </g>
              </g>
            </svg>
          </b-button>
          <h2 class="pb-4 pt-3">{{ course.course_title }}</h2>
          <p v-html="course.course_description"></p>
          <p class="my-5">
            <span class="duration" v-if="totalDuration > 0"
              ><i class="far fa-clock"></i> {{ totalDuration }}</span
            >
            <span class="modules px-5"
              ><i class="fa fa-volume-up"></i>
              {{ modules.length }} {{componentText.chapters}}</span
            >
          </p>
          <b-button class="cta-button py-4 px-5" @click="selectModule(0)"
            >{{componentText.start}}</b-button
          >
        </div>
        <div class="col-md-3 offset-4 d-none d-md-flex pr-5 icons">
          <div class="course-icon">
            <img :src="course.featured_img" />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white py-5" v-if="!loading">
      <div class="content-container row py-5 my-5">
        <div class="col-md-4 chapters">
          <h3>{{componentText.courseChapters}}</h3>
          <div class="session-menu">
            <div
              v-for="(session, i) in modules"
              :key="i"
              class="session-item mb-4 pb-2"
              :class="{ active: activeIndex === i, complete: activeIndex > i }"
              @click="selectModule(i)"
            >
              <div class="session-icon" v-html="icons[session.type]">

              </div>
              <div class="session-index">
                <h4 class="mb-0 mr-2">{{ i + 1 }}:</h4>
              </div>
              <div class="session-title " :class="{'mb-4': session.duration === '0 mins'}">
                <h4 class="mb-0">{{ session.title }}</h4>
                <p v-if="session.duration !== '0 mins'">{{ session.duration }}</p>
              </div>
            </div>
          </div>
        </div>
        <div id="module-content" class="col-md-7 offset-1 pl-5">
          <div class="active-module ">
            <div class="video-module" v-if="activeModule.type === 'video'">
              <GAVideoPlayer
                  v-if="!decodedEmbed"
                  :src="activeModule.asset_url"
                  ref="media"
                  @ended="nextModule()"/>
              <div v-else v-html="decodedEmbed"></div>
            </div>
            <div class="audio-module" v-if="activeModule.type === 'audio'">
              <h3>{{ activeModule.title }}</h3>
              <audio
                controls
                class="audio-player"
                ref="media"
                :key="activeModule.module_id"
                @ended="nextModule()"
                @canplay="playAudio"
              >
                <source :src="activeModule.asset_url" type="audio/mpeg" ref="audioSrc"/>
              </audio>
            </div>
            <div class="text-module" v-if="activeModule.type === 'text'">
              <h3>{{ activeModule.title }}</h3>
              <div v-html="activeModule.content"></div>
              <div class="buttons">
                <b-button
                  v-if="activeIndex < modules.length - 1"
                  @click="nextModule()"
                  class="px-5 py-3 my-5 cta-button"
                  >{{componentText.next}}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white" v-else>
      <b-spinner></b-spinner>
    </div>
  </div>
</template>

<script>
import GAVideoPlayer from "../components/GAVideoPlayer.vue";
import config from "@/config/constants";

export default {
  name: "WellbeingCourse",
  components: {GAVideoPlayer},
  data() {
    return {
      course: {},
      author: {},
      modules: [],
      progress: 0,
      totalDuration: 0,
      activeModule: {},
      activeIndex: 0,
      loading: true,
      icons: {
        audio: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.74 39.72\"><path class=\"cls-1\" fill=\"#E83B75\" d=\"M23.39,34.85c.08-.68.17-1.34.23-2,0-.17.11-.22.24-.27a15.88,15.88,0,0,0,6-4.27,15.27,15.27,0,0,0,3.65-7.51A15.64,15.64,0,0,0,30.82,8.7a15.55,15.55,0,0,0-8.55-6.1A14.94,14.94,0,0,0,16.67,2,15.72,15.72,0,0,0,5.12,8.41a14.88,14.88,0,0,0-3,7.23A15.66,15.66,0,0,0,5.73,28.08a15.35,15.35,0,0,0,6.19,4.51.26.26,0,0,1,.19.25c.06.66.14,1.32.21,2a17.85,17.85,0,1,1,11.07,0Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M23.8,27a6.78,6.78,0,0,0-.48-1.91c-.05-.12,0-.17.09-.23a8.81,8.81,0,0,0,2.16-2.47,8.61,8.61,0,0,0,1.2-5.24,8.78,8.78,0,0,0-4.22-6.9A8.39,8.39,0,0,0,17.41,9a8.57,8.57,0,0,0-7.23,4.42,8.61,8.61,0,0,0,.25,9.42,7.91,7.91,0,0,0,1.92,2.08c.08.06.14.11.08.23A6.49,6.49,0,0,0,12,27,10.92,10.92,0,0,1,7,17,10.92,10.92,0,1,1,23.8,27Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M14,29.48c0-.85,0-1.7,0-2.54a3.17,3.17,0,0,1,1.08-2.22,3.6,3.6,0,0,1,1.8-.81,5.86,5.86,0,0,1,2.36.07,3.19,3.19,0,0,1,2.55,2.81,15.3,15.3,0,0,1,.06,2.87c-.06,1.29-.14,2.58-.28,3.87a12.66,12.66,0,0,1-1.07,4.27,3.66,3.66,0,0,1-1.25,1.53,2.69,2.69,0,0,1-3.56-.71,6.77,6.77,0,0,1-1.05-2.45,22.75,22.75,0,0,1-.57-4c-.06-.89-.09-1.78-.13-2.66Zm2,0h0c0,.84.07,1.69.12,2.53a20.76,20.76,0,0,0,.54,3.77,4.86,4.86,0,0,0,.65,1.6.68.68,0,0,0,1.21,0,4.87,4.87,0,0,0,.45-.88,12.27,12.27,0,0,0,.66-2.8,36.51,36.51,0,0,0,.32-4.43c0-.7,0-1.4,0-2.1a1.26,1.26,0,0,0-1.14-1.28,3.9,3.9,0,0,0-1.56,0,1.25,1.25,0,0,0-1.17,1.28C15.89,27.92,15.93,28.7,15.93,29.47Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M17.88,13.9a4,4,0,1,1-4,3.83A4,4,0,0,1,17.88,13.9Zm-2,3.94a2,2,0,0,0,2,2,2,2,0,1,0-2-2Z\"/></g></g></svg>",
        text: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.24 33.44\"><path class=\"cls-1\" fill=\"#E83B75\" d=\"M5.56,7V6.79c0-1,0-1.92,0-2.88a2.37,2.37,0,0,1,2-2.37,3.15,3.15,0,0,1,.61-.06h17A.77.77,0,0,1,26,2a.73.73,0,0,1-.65.92H8.14a1.11,1.11,0,0,0-.92.39A.89.89,0,0,0,7,3.92V28.4a6.09,6.09,0,0,1-1,3.47A.48.48,0,0,0,6,32h.24q10.91,0,21.81,0a2.94,2.94,0,0,0,2.36-1.14,3.36,3.36,0,0,0,.8-2.23c0-5.06,0-10.13,0-15.19a1.67,1.67,0,0,1,0-.39.74.74,0,0,1,.75-.51.72.72,0,0,1,.67.62,1.93,1.93,0,0,1,0,.24V28.65a4.86,4.86,0,0,1-3.32,4.61,3.59,3.59,0,0,1-1.08.17H3.3A2.77,2.77,0,0,1,1,32.17,5.31,5.31,0,0,1,0,29.4c0-.34,0-.68,0-1V9.56A2.68,2.68,0,0,1,.58,7.77,2,2,0,0,1,2.15,7H5.56Zm0,1.47H2.16a.55.55,0,0,0-.55.41,2.35,2.35,0,0,0-.13.74v19a8.4,8.4,0,0,0,.12,1.23,3.41,3.41,0,0,0,.86,1.75,1.26,1.26,0,0,0,1.32.34,1.8,1.8,0,0,0,1-.79,4.49,4.49,0,0,0,.79-2.68v-20Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M36.24,3.73a2.13,2.13,0,0,1-.65,1.56q-4.19,4.2-8.38,8.41-5.66,5.7-11.33,11.39a.93.93,0,0,1-.49.23c-.37.06-.74.16-1.11.25l-3.54.88a.73.73,0,0,1-.94-.94c.39-1.53.79-3.06,1.17-4.59a1.29,1.29,0,0,1,.37-.65Q21.11,10.51,30.86.72A2.32,2.32,0,0,1,33.19.08a4.1,4.1,0,0,1,3,3.29C36.23,3.49,36.23,3.61,36.24,3.73ZM15.77,23.14a2.07,2.07,0,0,1,.15-.2q9.3-9.33,18.61-18.65a.76.76,0,0,0,.23-.72,2.64,2.64,0,0,0-2.06-2.1.77.77,0,0,0-.73.21L13.35,20.33a1.89,1.89,0,0,1-.19.14A4.91,4.91,0,0,1,15.77,23.14Zm-4.91,2.31,2.94-.84.7-.21a4,4,0,0,0-2.38-2.74c-.13.53-.72,2-.84,2.53Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M22.93,28.59H18.29a1.23,1.23,0,0,1-.47-.09.68.68,0,0,1-.41-.75.76.76,0,0,1,.6-.61.82.82,0,0,1,.22,0h9.4a.75.75,0,0,1,.75.42.73.73,0,0,1-.61,1H22.93Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M24.67,22.94h3a.79.79,0,0,1,.64.24.69.69,0,0,1,.15.73.67.67,0,0,1-.55.47l-.31,0c-1.93,0-3.85,0-5.77,0a1.32,1.32,0,0,1-.59-.15.67.67,0,0,1-.29-.79.72.72,0,0,1,.62-.52h3.14Z\"/><path class=\"cls-1\" fill=\"#E83B75\" d=\"M26.4,20.23H25.12a.73.73,0,0,1-.77-.73.73.73,0,0,1,.76-.73h2.6a.74.74,0,0,1,.72.5.7.7,0,0,1-.25.8.93.93,0,0,1-.48.15C27.27,20.25,26.83,20.23,26.4,20.23Z\"/></g></g></svg>",
        video: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 39 22.21\"><path class=\"cls-1\" fill=\"#E83B75\" d=\"M9.31,22.21V20.57H26a2.77,2.77,0,0,0,2.95-3c0-1.25,0-2.49,0-3.74,0-3,0-6.15,0-9.23a3,3,0,0,0-.84-2.17A3,3,0,0,0,26,1.62H26l-4.5,0H4.51A2.7,2.7,0,0,0,1.66,4.5V17.64a2.75,2.75,0,0,0,2.93,2.93H6.77V22.2H4.51A4.33,4.33,0,0,1,.07,18.45a4.47,4.47,0,0,1,0-.84v-4.1c0-2.93,0-6,0-8.95A4.46,4.46,0,0,1,3.84,0a4.67,4.67,0,0,1,.52,0H26.24a4.27,4.27,0,0,1,4.24,3.5,7.36,7.36,0,0,1,.1,1.43c0,.19,0,.37,0,.56s0,.62,0,1v1.2l1-.63.75-.45,1.11-.68,4.11-2.55a1.2,1.2,0,0,1,.61-.22.76.76,0,0,1,.38.11.88.88,0,0,1,.42.88q0,7,0,14a.89.89,0,0,1-.43.88.72.72,0,0,1-.36.11h0a1.29,1.29,0,0,1-.62-.22L33,16l-1.36-.84L31.34,15l-.74-.43v3.12a4.34,4.34,0,0,1-3,4.24,4.61,4.61,0,0,1-1.52.24l-11.65,0ZM30.59,12.09a.85.85,0,0,0,.45.8c1.21.73,2.41,1.48,3.61,2.22l2.68,1.65V5.25l-.62.3-.12.06L36,6,31,9.09a.88.88,0,0,0-.36.68v1c0,.33,0,.66,0,1v.29Z\" transform=\"translate(0)\"/></g></g></svg>",
        image: "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"far\" data-icon=\"images\" class=\"svg-inline--fa fa-images fa-w-18\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><path class=\"cls-1\" fill=\"#E83B75\" d=\"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z\"></path></svg>",
        check: "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"far\" data-icon=\"check-square\" class=\"svg-inline--fa fa-check-square fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path class=\"cls-1\" fill=\"#E83B75\" d=\"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z\"></path></svg>"
      }
    };
  },
  mounted() {
    this.getCourse();
  },
  watch: {
    activeModule() {
      if(this.activeModule.type === 'audio') {
        this.$refs.media.load();
      }
    }
  },
  methods: {
    async getCourse() {
      const payload = {
        user_id: this.$store.getters.user_id,
        course_id: this.$route.params.id
      };
      let res = await this.axios.post(
        process.env.VUE_APP_API_PATH +
          "/application/api/u/resources/get-course",
        payload, config.options
      );
      if (res.data.success) {
        this.course = res.data.course.course;
        this.author = res.data.course.author;
        this.modules = res.data.course.modules;
        this.progress = res.data.course.progress;
        this.totalDuration = res.data.course.duration;
        this.setInitialActiveModule(res.data.course.modules);
        this.loading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    setInitialActiveModule(modules) {
      if (this.$store.state.accessCode) {
        this.activeModule = modules[0];
        this.modules[0].is_active = true;
        this.activeIndex = 0;
      } else {
        for (let module in modules) {
          if (modules[module].complete === 0) {
            this.activeModule = modules[module];
            this.modules[module].is_active = true;
            this.activeIndex = module;
            return;
          }
        }
        this.activeModule = modules[0];
        this.modules[0].is_active = true;
        this.activeIndex = 0;
      }
    },
    selectModule(index) {
      this.activeModule = this.modules[index];
      this.activeIndex = index;
      const scrollTo = document.getElementById("module-content");
      scrollTo.scrollIntoView({ behavior: "smooth" });
      if (this.activeModule.type !== "text") {
        this.$nextTick().then(() => {
          this.$refs.media.play();
        });
      }
    },
    playAudio() {
      this.$refs.media.play();
    },
    previousModule() {
      this.selectModule(this.activeIndex - 1);
    },
    nextModule() {
      this.completeCourseModule(this.activeModule.id);
      this.selectModule(this.activeIndex + 1);
    },
    async completeCourseModule(id) {
      const payload = {
        user_id: this.$store.getters.user_id,
        module_id: id
      };
      await this.axios.post(
        process.env.VUE_APP_API_PATH +
          "/application/api-hc/complete-course-module",
        payload, config.options
      );
    },
  },
  computed:{
    decodedEmbed() {
      return this.activeModule.embed_code ? atob(this.activeModule.embed_code) : null;
    },
    componentText() {
      return this.getText.wellbeingCourse;
    },
  }
};
</script>

<style lang="less">
#WellbeingCourse {
  .return {
    background-color: transparent;
    svg {
      width: 35px;
      .cls-1 {
        fill: #ea3975;
      }
      .cls-2 {
        fill: #fff;
      }
    }
    &:hover {
      .cls-1 {
        fill: darken(#ea3975, 10%);
      }
    }
  }
  .page-title{
    h2{
      font-size: 3.8rem;
      letter-spacing: 0;
      text-align: left;
      font-family: "FilsonProBold", sans-serif;
    }
    p{
      font-size: 1.6rem;
    }
  }
  .icons {
    position: relative;
    .course-icon {
      width: 100%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
  .chapters{
    h3{
      font-family: FilsonProLight, sans-serif;
      font-size: 2.8rem;
      letter-spacing: 0;
      padding: 0 0 15px 0;
    }
  }
  .session-menu {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      left: 50px;
      top: 8px;
      height: calc(100% - 50px);
      width: 1px;
      background-color: #cccccc;
    }
    .session-item {
      display: flex;
      flex-direction: row;
      color: #e6007e;
      cursor: pointer;
      .session-icon {
        font-size: 2.5rem;
        margin-right: 50px;
        position: relative;
        display: flex;
        align-items: flex-start;
          width: 28px;
        height: 31px;
        display: flex;
        align-items: center;
          svg {
              width: 28px;
          }
        &:after {
          position: absolute;
          top: 8px;
          right: -28px;
          content: "";
          border-radius: 50%;
          width: 10px;
          height: 10px;
          background-color: #cccccc;
        }
      }
      h4 {
        font-family: FilsonProBold, sans-serif;
      }
      p {
        font-size: 1.6rem;
      }
      &.active,
      &:hover {
        color: darken(#e6007e, 10%);
        .session-icon svg {
          .cls-1 {
            fill: darken(#e6007e, 10%);
          }
        }
        .session-icon:after {
          background-color: darken(#e6007e, 10%);
        }
      }
      &.complete {
        color: #cccccc;
        p {
          color: #cccccc;
        }
        .session-icon svg {
          .cls-1 {
            fill: #cccccc;
          }
        }
      }
    }
  }
  .active-module {
    h3 {
      font-family: "Open Sans", sans-serif;
      font-size: 1.8rem;
      font-weight: 700;
      padding-top: 0;
    }
    video {
      width: 100%;
      border-radius: 36px;
      border: 1px solid #afb0b2;
      &:focus {
        outline: none;
      }
    }
    .audio-player {
      width: 100%;
      border: 1px solid #2686b1;
      border-radius: 30px;
      color: #2686b1;
      &:focus {
        outline: none;
      }
    }
    .text-module {
      font-size: 1.6rem;
      .buttons {
        width: 100%;
        text-align: center;
        .btn {
          font-size: 1.7rem;
        }
      }
    }
  }
}
#completed-modal {
  .modal-content {
    border-radius: 30px;
    text-align: center;
    height: 400px;
    max-width: 600px;
    width: 100%;
    position: relative;
    border-width: 0;
    color: #3a4961;
    .modal-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .icon-wrap {
      width: 150px;
      img {
        width: 100%;
      }
    }
    h2 {
      font-size: 2.3rem;
      font-family: FilsonProBold, sans-serif;
    }
    p {
      font-size: 2rem;
      font-family: DMSans, sans-serif;
    }
    .cta-button {
      color: #e6007e;
      background-color: #fff;
      border: 1px solid #e6007e;
      border-radius: 30px;
      font-size: 1.6rem;
      font-family: FilsonProBold, sans-serif;
      &:hover {
        background-color: #e6007e;
        color: #fff;
      }
    }
    .close {
      position: absolute;
      top: 15px;
      right: 20px;
      color: #e6007e;
      opacity: 1;
      cursor: pointer;
      font-size: 2.8rem;
      &:hover {
        color: darken(#e6007e, 10%);
      }
    }
  }
}
</style>
